export const ADD_SUBCHARACTER = 'ADD_SUBCHARACTER'
export const HERO_GENERATION_PARAM_COLLECTION_UPDATE = 'HERO_GENERATION_PARAM_COLLECTION_UPDATE'
export const REGENERATE_HERO = 'REGENERATE_HERO'
export const REGENERATE_SUBCHARACTER = 'REGENERATE_SUBCHARACTER'
